import * as React from "react";
import { css } from "@emotion/core";

export const Footer = () => (
  <footer
    css={css`
      padding-top: 200px;
      background: #fff;
      color: #373742;

      .link a {
        color: #373742;
      }
    `}
  >
    <div className="link">
      <a href="/">TOP</a>
      <span>|</span>
      <a href="/company">会社概要</a>
      <span>|</span>
      <a href="/privacy">プライバシーポリシー</a>
      <span>|</span>
      <a href="/laws">特定商取引法に基づく表記</a>
    </div>
    <div className="copyright">copyright 2019 Postal.</div>
  </footer>
);
